import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';

export function useMfaEnabled() {
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    const { isMfaEnabled } = getFeaturesByClientId();
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_MFA?.toString())?.flagValue ?? false;
    const isFlagEnabled = enabled === true || enabled === 'true';
    setMfaEnabled(isFlagEnabled && isMfaEnabled);
  }, [flagsContext]);

  return { mfaEnabled };
}
